module.exports.NewtonCoinIcon = require('./NewtonCoinIcon.js')
module.exports.NewtonLogoFull = require('./NewtonLogoFull.js')
module.exports.BinanceCoinIcon = require('./BinanceCoinIcon.js')
module.exports.BinanceLogoFull = require('./BinanceLogoFull.js')
module.exports.CameraCircleArrowOutline = require('./CameraCircleArrowOutline.js')
module.exports.ScanQrOutline = require('./ScanQrOutline.js')
module.exports.XMarkIcon = require('./XMarkIcon.js')
